module.exports = __webpack_public_path__ + "static/media/aadhar_verify.b980244a.svg";